<template>
  <!-- 移动端app下载页面 -->
  <div class="app-rule">
    <div>
      <img
        class="img"
        style="width: 100px"
        src="@/assets/images/appIcon.png"
        alt=""
      />
    </div>
    <p class="mat10">自考乐app.apk</p>
    <el-button class="mat50" type="primary" @click="getAndroidUrl"
      >安装下载</el-button
    >
  </div>
</template>

<script>
import { getAndroidUrl } from "@/api/home";
export default {
  name: "",
  components: {},
  data() {},
  mounted() {},
  methods: {
    // 获取android的下载地址并生成android二维码
    async getAndroidUrl() {
      const res = await getAndroidUrl();
      if (res) {
        window.location.href = res.file;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-rule {
  position: fixed;
  font-size: 14px;
  width: 100%;
  background: #fff;
  padding: 20px;
  height: 100%;
  overflow: auto;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .img {
    border-radius: 10px;
    border: 1px solid #e5e5e5;
  }
}
</style>
